module.exports = __webpack_public_path__ + "img/reward-3.462c1830.png";